import { createFileRoute } from "@tanstack/react-router"
import { useTranslate } from "src/domains/i18n/use-translate"
import backdropImage from "src/ui/assets/buildings-orange-brown.jpg"
import { PageLayout } from "src/ui/page-layout/page-layout"

import { ChangePasswordForm } from "./-change-password-form"

export const Route = createFileRoute("/password/change/")({
  component: ChangePassword,
})

function ChangePassword() {
  const { tPlaceholder } = useTranslate()

  return (
    <PageLayout
      title={tPlaceholder("Change password")}
      landscapeImageUrl={backdropImage}
      portraitImageUrl={backdropImage}
    >
      <ChangePasswordForm />
    </PageLayout>
  )
}
